module.exports = __webpack_public_path__ + "img/pendiente_a.77c025d4.png";